var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deal-list',{attrs:{"status":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }